export default __webpack_public_path__ + "static/parturi-slg-9e9f3ef9df27219db12ed9a3a6b04d76.jpg";